import { render, staticRenderFns } from "./RotationMobile.vue?vue&type=template&id=6c7905e9&scoped=true&"
import script from "./RotationMobile.vue?vue&type=script&lang=ts&"
export * from "./RotationMobile.vue?vue&type=script&lang=ts&"
import style0 from "./RotationMobile.vue?vue&type=style&index=0&id=6c7905e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7905e9",
  null
  
)

export default component.exports